module.exports = __webpack_public_path__ + "static/emiway-1e70823607995cb0717e14488831fa7b.png";